import rc from 'randomcolor';

enum luminosity {
  light = 'light',
  bright = 'bright',
  dark = 'dark'
}
const light: any = {
  luminosity: luminosity.light
};
/*
const bright: any = {
  luminosity: luminosity.bright
};
*/
const dark: any = {
  count: 50,
  luminosity: luminosity.dark
};

export const avatarColors = rc(dark);

export const tagColors = [
  {a: rc(light)},
  {b: rc(light)},
  {c: rc(light)},
  {d: rc(light)},
  {e: rc(light)},
  {f: rc(light)},
  {g: rc(light)},
  {h: rc(light)},
  {i: rc(light)},
  {j: rc(light)},
  {k: rc(light)},
  {l: rc(light)},
  {m: rc(light)},
  {n: rc(light)},
  {o: rc(light)},
  {p: rc(light)},
  {q: rc(light)},
  {r: rc(light)},
  {s: rc(light)},
  {t: rc(light)},
  {u: rc(light)},
  {v: rc(light)},
  {w: rc(light)},
  {x: rc(light)},
  {y: rc(light)},
  {z: rc(light)}
];
